import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('dialogs-container', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('dialogs-container');

      return new ViewModel(params, element);
    },
  },
  template: html,
});